import { useEffect, useMemo, useState } from 'react';

import cn from 'classnames';

import { SpotTradeAPI } from '@api/spotTrade';
import helper from '@utils/helper';
import { I18n } from '@utils/index';

import { getListData, handleZoneList } from '../TradeList/utils';

import styles from './index.module.less';

export const useZoneList = (store) => {
  const [currency, setCurrency] = useState<string | number>('USDT');
  const [zone, setZone] = useState<string>('ALL');
  const [categories, setCategories] = useState([]);
  const [tickerList, setTickerList] = useState([]);
  const [loading, setLoading] = useState(false);
  const { tradeStore, marketStore } = store;
  const { baseCurrenciesList = [] } = marketStore;
  const options = useMemo(() => {
    return baseCurrenciesList.map(baseItem => {
      const { currency } = baseItem;
      return {
        value: currency,
        label: <span className={cn(styles.labelClass, 'DINPro')}>{currency}</span>,
        dataBuried: `web_market_markets_spot_stablecurrencytype_select_${currency}`
      }
    })
  }, [baseCurrenciesList])

  const [selectOptions, setSelectOptions] = useState(options);
  const { symbols } = tradeStore.favoriteObject;

  // 所有板块
  const getZoneList = async () => {
    setLoading(true);
    const response = await SpotTradeAPI.getZoneList({ includeKline: true });
    if (response?.success && response?.obj) {
      setCategories(response?.obj);
    } else {
      helper.handleErrorMsg(response?.msgKey);
    }
    setLoading(false);
  };

  useEffect(() => {
    getZoneList();
  }, []);

  useEffect(() => {
    setSelectOptions(options)
  }, [options])

  const zoneData = useMemo(() => {
    const list = categories;
    // .sort((a, b) => a.order - b.order)
    if (list[0]?.categoryKey !== 'ALL') {
      list.unshift({
        categoryKey: 'ALL',
        categoryName: I18n.t('QkabILoa')
      });
    }
    return list;
  }, [categories]);

  // 板块详情
  const getZoneDetail = async (categoryKey, currency = 'USDT') => {
    setLoading(true);
    const response = await SpotTradeAPI.getZoneDetail({
      key: categoryKey,
      currency
    });
    if (response?.success && response?.obj) {
      setTickerList(response.obj?.tickerList);
    } else {
      helper.handleErrorMsg(response?.msgKey);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (zone !== 'ALL') {
      getZoneDetail(zone);
      setSelectOptions((pre) => {
        return pre.filter((i) => i.value === 'USDT');
      });
    } else {
      setSelectOptions(options);
    }
    setCurrency('USDT');
  }, [zone]);

  const data = useMemo(
    () =>
      zone === 'ALL'
        ? getListData(currency, marketStore)
        : handleZoneList({
          dataList: tickerList,
          marketStore
        }),
    [zone, currency, symbols, tickerList, { ...marketStore }]
  );

  const tabsChange = (key) => {
    setZone(key);
  }

  return {
    currency,
    zone,
    selectOptions,
    loading,
    dataList: data,
    zoneData,
    categories,
    tabsChange,
    setCurrency
  };
};
